module.exports = __webpack_public_path__ + "img/download.806f6c17.svg";